"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var menu_1 = require("../menu");
var avatar_1 = require("../avatar");
var userBanner_1 = require("../userBanner");
var surface_1 = require("../surface");
var nativeLink_1 = require("../nativeLink");
var react_transition_group_1 = require("react-transition-group");
var UserMenu = /** @class */ (function (_super) {
    tslib_1.__extends(UserMenu, _super);
    function UserMenu(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.open = function () {
            var isOpen = _this.state.isOpen;
            if (!isOpen) {
                _this.setState({ isOpen: true });
            }
        };
        _this.close = function () {
            var isOpen = _this.state.isOpen;
            if (isOpen) {
                _this.setState({ isOpen: false });
            }
        };
        _this.onMenuItemClick = function (e) {
            var onItemClick = _this.props.onItemClick;
            _this.close();
            onItemClick && onItemClick(e);
        };
        _this.setSurfaceRef = function (el) {
            _this.$surface = el;
        };
        _this.renderLinks = function () {
            var _a = _this.props, theme = _a.theme, links = _a.links;
            var LinkComponent = _this.context.linkComponent;
            if (links.length === 0) {
                return null;
            }
            return (React.createElement("div", { className: theme.links }, links.map(function (link, i) { return (!link.native && LinkComponent
                ? React.createElement(LinkComponent, tslib_1.__assign({ key: i }, link.linkProps), link.label)
                : React.createElement(nativeLink_1.NativeLink, tslib_1.__assign({ key: i }, link.linkProps), link.label)); })));
        };
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.state = { isOpen: false, verticalPosition: "top", horizontalPosition: "right" };
        _this.$surface = null;
        _this.$el = null;
        return _this;
    }
    UserMenu.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.isOpen && !prevState.isOpen) {
            this.handlePosition();
        }
    };
    UserMenu.prototype.componentWillUnmount = function () {
        this.$surface = null;
    };
    UserMenu.prototype.handlePosition = function () {
        var elRect = this.$el.getBoundingClientRect();
        var surfaceRect = this.$surface.getBoundingClientRect();
        var nextState = {
            horizontalPosition: elRect.left + elRect.width - surfaceRect.width < 0 ? "left" : "right",
            verticalPosition: elRect.top + surfaceRect.height > window.innerHeight ? "bottom" : "top"
        };
        if (this.state.horizontalPosition !== nextState.horizontalPosition || this.state.verticalPosition !== nextState.verticalPosition) {
            this.setState(nextState);
        }
    };
    UserMenu.prototype.getSurfaceTransitionClasses = function () {
        var theme = this.props.theme;
        return {
            enter: theme.surfaceEnter,
            enterActive: theme.surfaceEnterActive,
            exit: theme.surfaceLeave,
            exitActive: theme.surfaceLeaveActive
        };
    };
    UserMenu.prototype.renderMenu = function () {
        var _a;
        var _b = this.props, theme = _b.theme, children = _b.children, surfaceLevel = _b.surfaceLevel, avatarUrl = _b.avatarUrl, userName = _b.userName, userEmail = _b.userEmail, verticalGap = _b.verticalGap, horizontalGap = _b.horizontalGap;
        var _c = this.state, verticalPosition = _c.verticalPosition, horizontalPosition = _c.horizontalPosition;
        var surfaceStyle = (_a = {},
            _a[verticalPosition] = "" + utils_1.toREMString(verticalGap),
            _a[horizontalPosition] = "-" + utils_1.toREMString(horizontalGap),
            _a.transformOrigin = horizontalPosition + " " + verticalPosition,
            _a);
        return (React.createElement(surface_1.Surface, { key: "surface", exposedRef: this.setSurfaceRef, className: theme.surface, style: surfaceStyle, level: surfaceLevel },
            React.createElement("div", { className: theme.banner },
                React.createElement(userBanner_1.UserBanner, { avatarUrl: avatarUrl, title: userName, description: userEmail })),
            React.createElement(menu_1.Menu, { surfaceLevel: 0, onItemClick: this.onMenuItemClick }, children),
            this.renderLinks()));
    };
    UserMenu.prototype.render = function () {
        var _a = this.props, children = _a.children, theme = _a.theme, className = _a.className, avatarUrl = _a.avatarUrl, smallAvatar = _a.smallAvatar, largeAvatar = _a.largeAvatar, darkAvatar = _a.darkAvatar, userName = _a.userName, userEmail = _a.userEmail, verticalGap = _a.verticalGap, horizontalGap = _a.horizontalGap, links = _a.links, others = tslib_1.__rest(_a, ["children", "theme", "className", "avatarUrl", "smallAvatar", "largeAvatar", "darkAvatar", "userName", "userEmail", "verticalGap", "horizontalGap", "links"]);
        var isOpen = this.state.isOpen;
        var classes = classnames_1.default(theme.menu, className);
        return (React.createElement("div", { ref: this.setRef, className: classes, onMouseEnter: this.open, onMouseLeave: this.close },
            React.createElement(avatar_1.Avatar, { small: smallAvatar, large: largeAvatar, dark: darkAvatar, imageUrl: avatarUrl }),
            React.createElement(react_transition_group_1.CSSTransition, { in: isOpen, unmountOnExit: true, classNames: this.getSurfaceTransitionClasses(), timeout: 200 }, this.renderMenu())));
    };
    UserMenu.defaultProps = {
        surfaceLevel: 2,
        verticalGap: 6.8,
        horizontalGap: 2,
        links: []
    };
    UserMenu.contextTypes = {
        linkComponent: PropTypes.any
    };
    return UserMenu;
}(React.Component));
exports.default = UserMenu;
